package app.bloomey.web.components.sections

import androidx.compose.runtime.Composable
import androidx.compose.runtime.key
import app.bloomey.web.components.widgets.Height
import app.bloomey.web.components.widgets.LogoutIconColorVariant
import app.bloomey.web.components.widgets.NavItem
import app.bloomey.web.components.widgets.NavItemActiveVariant
import app.bloomey.web.core.data.Envars
import app.bloomey.web.core.modal.LocalSiteModelController
import app.bloomey.web.core.modal.modals.LogoutModal
import app.bloomey.web.core.res.*
import app.bloomey.web.theme.toSitePalette
import com.varabyte.kobweb.compose.css.Cursor
import com.varabyte.kobweb.compose.foundation.layout.Column
import com.varabyte.kobweb.compose.foundation.layout.Spacer
import com.varabyte.kobweb.compose.ui.Alignment
import com.varabyte.kobweb.compose.ui.Modifier
import com.varabyte.kobweb.compose.ui.graphics.Colors
import com.varabyte.kobweb.compose.ui.graphics.lightened
import com.varabyte.kobweb.compose.ui.modifiers.*
import com.varabyte.kobweb.compose.util.kebabCaseToTitleCamelCase
import com.varabyte.kobweb.core.rememberPageContext
import com.varabyte.kobweb.silk.components.animation.toAnimation
import com.varabyte.kobweb.silk.components.graphics.Image
import com.varabyte.kobweb.silk.components.overlay.Overlay
import com.varabyte.kobweb.silk.components.overlay.OverlayVars
import com.varabyte.kobweb.silk.components.text.SpanText
import com.varabyte.kobweb.silk.theme.SilkTheme
import com.varabyte.kobweb.silk.theme.colors.ColorMode
import com.varabyte.kobweb.silk.theme.colors.palette.color
import org.jetbrains.compose.web.css.*

@Composable
fun AdminSideBar(modifier: Modifier = Modifier) {
    val pageContext = rememberPageContext()
    val router = pageContext.router
    val route = pageContext.route

    val checkActive = { value: String ->
        if (route.path == value) NavItemActiveVariant else null
    }
    val modalController = LocalSiteModelController.current

    Column(
        modifier = modifier.fillMaxHeight().bottom(0.px).top(0.px).maxHeight(100.vh)
            .padding(leftRight = 20.px, topBottom = 30.px).background(ColorMode.current.toSitePalette().nearBackground)
    ) {
        Image(Res.Assets.logo, width = 140, modifier = Modifier
            .cursor(Cursor.Pointer)
            .onClick { router.navigateTo(Res.Destinations.adminPage) })
        SpanText(
            "Admin",
            modifier = Modifier.margin(top = 8.px).fontSize(16.px).color(SilkTheme.palette.color.lightened(0.5f))
        )
        SpanText(
            text = Envars.environment.name.kebabCaseToTitleCamelCase(),
            modifier = Modifier.margin(top = 4.px).fontSize(12.px)
        )
        Height(60.px)
        Column(modifier = Modifier.fillMaxWidth()) {
            NavItem(
                image = Res.Assets.icHome, title = "Dashboard", variant = checkActive(Res.Destinations.adminPage)
            ) {
                router.navigateTo(Res.Destinations.adminPage)
            }

            NavItem(
                image = Res.Assets.icUser, title = "Users", variant = checkActive(Res.Destinations.users)
            ) {
                router.navigateTo(Res.Destinations.users)
            }

            NavItem(
                image = Res.Assets.icFilmSlate, title = "Libraries", variant = checkActive(Res.Destinations.libraries)
            ) {
                router.navigateTo(Res.Destinations.libraries)
            }
            NavItem(
                image = Res.Assets.icPlay, title = "Videos", variant = checkActive(Res.Destinations.videos)
            ) {
                router.navigateTo(Res.Destinations.videos)
            }
            NavItem(
                image = Res.Assets.icChatCircle, title = "Feedback", variant = checkActive(Res.Destinations.feedbacks)
            ) {
                router.navigateTo(Res.Destinations.feedbacks)
            }
        }
        Spacer()
        NavItem(
            image = Res.Assets.ic_doorOpen, title = "Logout", color = Colors.Red, variant = LogoutIconColorVariant
        ) {
            modalController.push(LogoutModal())
        }
    }
}

enum class MenuSlideDirection {
    LeftRight, RightLeft
}

@Composable
fun FloatingSideBar(
    modifier: Modifier = Modifier,
    menuSlideDirection: MenuSlideDirection,
    menuState: SideMenuState,
    close: () -> Unit,
    onAnimationEnd: () -> Unit,
    sideBar: @Composable (modifier: Modifier) -> Unit,
) {
    Overlay(
        modifier
            .setVariable(OverlayVars.BackgroundColor, Colors.Transparent)
            .onClick { close() }
            .zIndex(3)
    ) {
        key(menuState) { // Force recompute animation parameters when close button is clicked
            sideBar(
                Modifier
                    .then(
                        when (menuSlideDirection) {
                            MenuSlideDirection.LeftRight -> Modifier.align(Alignment.CenterStart)
                            MenuSlideDirection.RightLeft -> Modifier.align(Alignment.CenterEnd)
                        }
                    )
                    .animation(
                        when (menuSlideDirection) {
                            MenuSlideDirection.LeftRight -> SideMenuSlideInLeftRightAnim
                            MenuSlideDirection.RightLeft -> SideMenuSlideInRightLeftAnim
                        }.toAnimation(
                            duration = 200.ms,
                            timingFunction = if (menuState == SideMenuState.OPEN) AnimationTimingFunction.EaseOut else AnimationTimingFunction.EaseIn,
                            direction = if (menuState == SideMenuState.OPEN) AnimationDirection.Normal else AnimationDirection.Reverse,
                            fillMode = AnimationFillMode.Forwards
                        )
                    )
                    .onClick { it.stopPropagation() }
                    .onAnimationEnd { onAnimationEnd() },
            )
        }
    }
}